import {
  FallbackHeaderContainer,
  FallbackHeaderImg,
  FallbackHeaderH1,
  FallbackHeaderH2,
  FallbackHeaderH3,
} from './styles';
const FallbackHeader = () => {
  return (
    <FallbackHeaderContainer>
      <FallbackHeaderImg src="/images/rise-master-logo-linear-rgb.png" alt="Rise Logo" />
      <FallbackHeaderH1>PARDON THE INTERRUPTION</FallbackHeaderH1>
      <FallbackHeaderH2>We&apos;re Rolling Out Some Updates</FallbackHeaderH2>
      <FallbackHeaderH3>
        We&apos;re making a few quick improvements behind the scenes. In the meantime, online ordering is still
        available — select your state below to shop your local RISE dispensary.
      </FallbackHeaderH3>
    </FallbackHeaderContainer>
  );
};

export default FallbackHeader;
